export const SurveyScoreEditingEnums = Object.freeze({
  RESPONDANT_EDITED: 'RESPONDANT_EDITED',
  RECOMM_EDITED: 'RECOMM_EDITED',
});
